export const routes = {
  default: '/',
  reviewPractitioner: '/review', // To keep backwards compatibility with emails
  reviewClinic: '/review/clinic',
  finish: '/finish',
  create: '/create',
  emailFeedback: '/email-feedback',
}
